import { Colors, Services, regExp } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import generatorRow from '@/components/generator/row'

const baseClass = 'packets'

function renderSizeField(h, item) {
  return h(
    components['text-field'],
    {
      props: {
        value: item.size,
        label: this.getTranslate(`${Services.tariffs}.labels.${baseClass}.size`),
        dense: true,
        details: false,
        mask: regExp.integer
      },
      on: {
        input: event => {
          item.size = event
        }
      }
    }
  )
}
function renderPriceField(h, item) {
  return h(
    components['text-field'],
    {
      props: {
        value: item.price,
        label: this.getTranslate(`${Services.tariffs}.labels.${baseClass}.price`),
        dense: true,
        details: false,
        mask: regExp.positiveNumberFourSymbolsAfterDot,
        suffix: this.getTranslate('currency.RUB.symbol.unicode'),
        processValue: value => {
          return value?.toString().replace(',', '.')
        }
      },
      on: {
        input: event => {
          item.price = event
        }
      }
    }
  )
}
function renderItem(h, item) {
  return h(
    'div',
    {
      class: `${Services.tariffs}-rule__${baseClass}-item`
    },
    [
      renderSizeField.call(this, h, item),
      renderPriceField.call(this, h, item)
    ]
  )
}
function renderItems(h) {
  return h(
    'div',
    {
      class: `${Services.tariffs}-rule__${baseClass}-dialog`
    },
    [
      h(
        generatorRow,
        {
          props: {
            value: this.items,
            sortable: true,
            defaultValue: this.createDefaultItem()
          },
          scopedSlots: {
            row: ({ item }) => {
              return renderItem.call(this, h, item)
            }
          },
          on: {
            input: event => {
              this.items = event
            }
          }
        }
      )
    ]
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: `${Services.tariffs}-rule__${baseClass}-dialog__footer`,
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.proxy = false
            }
          }
        }
      ),

      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.save'),
            mode: buttonModes.flat,
            color: Colors.primary,
            disabled: !this.canSave
          },
          on: {
            click: () => {
              return this.saveHandler()
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    components.dialog,
    {
      props: {
        value: this.proxy,
        title: this.getTranslate(`${Services.tariffs}.titles.${baseClass}`),
        maxWidth: 520
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    [
      renderItems.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
